interface AppConfigValues {
  api_base_url: string;
  app_name: string;
  github_client_id: string;
  ui_domain: string;
  seo: Seo;
  stripe: Stripe;
}

interface Seo {
  title: string;
}

interface Stripe {
  publishable_key: string;
}

// Default configuration
const defaultConfig: AppConfigValues = {
  api_base_url: "https://api.sellcode.dev",
  app_name: "Sell Code",
  github_client_id: "Ov23liha4be4gNGLmAHK",
  ui_domain: "https://sellcode.dev",
  seo: { title: "Sell Code" },
  stripe: {
    publishable_key:
      "pk_live_51PzQiAJhJjxgCn8ewM3scyf4dA13tQe4B8iVPvpySNb5T2bkkTYsYoAURTZDKAJH2daYQYuw8M06mUtkNqbFUVe200LUe1ELm4",
  },
};

// Function to merge configurations
const mergeConfig = (defaultConfig: AppConfigValues): AppConfigValues => {
  const isDevEnv = process.env.NODE_ENV === "development";
  if (isDevEnv) {
    return {
      ...defaultConfig,
      ui_domain: "http://localhost:3000",
      api_base_url: "http://127.0.0.1:8000",
      github_client_id: "Ov23li1SEimg3AUENwQm",
      stripe: {
        publishable_key:
          "pk_test_51PzQiAJhJjxgCn8ebRlNbWOabkRRdgikJbOyYkymISV6E78NEh670nIdoYzZLOHbRenpAB1qi31sozW6VK1efQDC00bKceFQjf",
      },
    };
  }
  return defaultConfig;
};

// Export the final configuration
const appConfig = mergeConfig(defaultConfig);
export default appConfig;
